<ul class='list'>
  <li>
    <a routerLink="/customers">
      <fa-icon [icon]="faLandmark"></fa-icon>

    </a>
  </li>
  <li>
    <i class="arrow right"></i>
  </li>

  <li *ngFor='let companyName of companyData '>
    <b> {{companyName.name}} </b>
  </li>
  <li>
    <button *ngIf="isAdmin" nz-button class="button custom-button" (click)="showModal()">
      Add Site
    </button>
  </li>
</ul>

<div *ngIf='noSites' class='info'>
  No sites available.
</div>
<ng-template #indicatorTemplate>
  <i nz-icon nzType="loading" class='loaderIcon'></i>
</ng-template>
<nz-spin [nzSpinning]="isLoading" [nzIndicator]="indicatorTemplate"></nz-spin>
<!-- https://stackblitz.com/edit/angular-y8ns59-fna8vw?file=src%2Fapp%2Fapp.component.ts -->

<div class='sitesContainer' *ngIf="siteData && siteData.length">
  <div class="de-admin-container" nz-row [nzGutter]="[16, 16]">
    <div class="gutter-row" *ngFor="let data of siteData" nz-col [nzSpan]="6">
      <div class="list">

        <h2 class="heading">
          <span *ngIf="data.type" style="padding-right: 4px;">
            <fa-icon *ngIf="data.type==='solar'" nz-tooltip nzTooltipTitle="Solar" [icon]="faSolarPanel"></fa-icon>
            <fa-icon *ngIf="data.type==='wind'" nz-tooltip nzTooltipTitle="Wind" [icon]="faWind"></fa-icon>

          </span>
          {{data?.static_data?.name?.value}} <span style="font-size: 14px;">({{data.id}})</span>

        </h2>
        <div class="body">
          <div *ngIf="data?.static_data?.is_clickhouse?.value!=='1' || data?.static_data?.auto_trend?.value!=='1'"
            style="font-size: 12px;margin-bottom: 8px;text-align: center;"><span>Auto Trend =
              {{data?.static_data?.auto_trend?.value==='1' ? 'Yes' :
              'No'}}</span>
            <span>, Clickhouse = {{data?.static_data?.is_clickhouse?.value==='1' ? 'Yes' : 'No'}}</span>
          </div>
          <div style="text-align: center;"><button nz-button class="button custom-button " style="cursor: pointer"
              (click)="detailsClick(data)">
              Update Config
            </button></div>
        </div>

      </div>
    </div>
  </div>
  <!-- <div *ngFor='let data of siteData' class='sites-wrapper'>

    <div class='sites-content'>
      <div>
        <a (click)="detailsClick(data)" style="text-align: center;font-size:30px;">
          {{data?.static_data?.name?.value}}
        </a>
      </div>
      <div *ngIf=" data.meta_data.type ==='solar'; else itsWind;">
        <fa-icon [icon]="faSolarPanel" [styles]="{ color: 'purple' }"></fa-icon>

        <a (click)="detailsClick(data)" style="text-align: center;font-size:30px;">
          {{data['meta_data']['name']}}
        </a>
      </div>
      <ng-template #itsWind>
        <fa-icon [icon]="faWind" [styles]="{ color: 'rebeccapurple' }"></fa-icon>
        <a (click)="detailsClick(data)" style="text-align: center;font-size:30px;">
          {{data['meta_data']['name']}}
        </a>
      </ng-template>
    </div>
    <div>
      <button (click)="detailsClick(data)" nz-button class="button custom-button " style="cursor: pointer">
        Update Config
      </button>
    </div>

    <div class='site1'><label>Ac capacity=</label> {{data['meta_data']['ac_capacity']/1000}}
      <span style="font-weight: bold;">MWP</span>
    </div>
    <div class='site1'><label>Dc capacity=</label> {{data['meta_data']['dc_capacity']/1000}}
      <span style="font-weight: bold;">MWP</span>
    </div>
    <div class='site1'><label>Coordinates</label> {{data['meta_data']['coordinates']}}</div>

  </div> -->

</div>

<div>
  <router-outlet></router-outlet>
</div>
<nz-modal [(nzVisible)]="isAddVisible" nzTitle="Add Site" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <div class="loading-contaner" *ngIf="isAddLoading">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <form nz-form>
      <p>
        <nz-input-group nzAddOnBefore="Site Id">
          <input type="text" nz-input name='siteId' [(ngModel)]="siteId" [class.error]="!siteId && isSiteNameError" />
        </nz-input-group>
      </p>
      <p>
        <nz-input-group nzAddOnBefore="Google Sheet Id">
          <input type="text" name='google' nz-input [(ngModel)]="sheetId" [class.error]="!sheetId && isError" />
        </nz-input-group>
      </p>
      <p *ngIf="submitFailedMessage">{{submitFailedMessage}}</p>
    </form>
  </ng-container>
</nz-modal>